var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawPolygon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 20C40 31.0457 31.0457 40 20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20Z",
    fill: "#329D9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1665 25.8511C25.1673 25.4847 24.8709 25.187 24.5045 25.1862L15.216 25.1652C14.8496 25.1644 14.5519 25.4607 14.5511 25.8272C14.5502 26.1936 14.8466 26.4913 15.213 26.4921L24.5015 26.5131C24.8679 26.5139 25.1656 26.2175 25.1665 25.8511Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9766 13.9344C17.9766 16.1074 16.191 17.8689 13.9883 17.8689C11.7856 17.8689 10 16.1074 10 13.9344C10 11.7615 11.7856 10 13.9883 10C16.191 10 17.9766 11.7615 17.9766 13.9344Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1077 13.9344C30.1077 16.1074 28.3221 17.8689 26.1194 17.8689C23.9167 17.8689 22.1311 16.1074 22.1311 13.9344C22.1311 11.7615 23.9167 10 26.1194 10C28.3221 10 30.1077 11.7615 30.1077 13.9344Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1077 26.0654C30.1077 28.2384 28.3221 29.9999 26.1194 29.9999C23.9167 29.9999 22.1311 28.2384 22.1311 26.0654C22.1311 23.8925 23.9167 22.131 26.1194 22.131C28.3221 22.131 30.1077 23.8925 30.1077 26.0654Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9766 26.0654C17.9766 28.2384 16.191 29.9999 13.9883 29.9999C11.7856 29.9999 10 28.2384 10 26.0654C10 23.8925 11.7856 22.131 13.9883 22.131C16.191 22.131 17.9766 23.8925 17.9766 26.0654Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1662 13.7201C25.167 13.3537 24.8706 13.056 24.5042 13.0551L15.2157 13.0342C14.8493 13.0333 14.5516 13.3297 14.5508 13.6961C14.5499 14.0626 14.8463 14.3603 15.2127 14.3611L24.5012 14.3821C24.8676 14.3829 25.1653 14.0865 25.1662 13.7201Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7568 25.1683C14.1232 25.1662 14.4185 24.8675 14.4164 24.5011L14.3635 15.2128C14.3615 14.8463 14.0627 14.551 13.6963 14.5531C13.3299 14.5552 13.0345 14.8539 13.0366 15.2203L13.0895 24.5087C13.0916 24.8751 13.3904 25.1704 13.7568 25.1683Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8878 25.1683C26.2542 25.1662 26.5496 24.8675 26.5475 24.5011L26.4946 15.2128C26.4925 14.8463 26.1938 14.551 25.8273 14.5531C25.4609 14.5552 25.1656 14.8539 25.1677 15.2203L25.2206 24.5087C25.2227 24.8751 25.5214 25.1704 25.8878 25.1683Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawPolygon);
export default __webpack_public_path__ + "static/media/draw-polygon.5fc87ff8e1b9c0313ac2631eec364a26.svg";
export { ForwardRef as ReactComponent };